import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import { get } from 'lodash';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ManualAlertEvent, Filter } from '@conviva/portal-graphql-schema';
import { useQuery } from '@apollo/react-hooks';
import { TEMP_DASHBOARD_URL, DASHBOARD_TYPE } from '@utils/constants';
import { useLocationQuery } from '@src/hooks';
import { ALERT_EVENT_QUERY } from '@api/graphql/manualAlerts';
import { Loading, PageNotFound } from '@components/common';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { dashboardsSelector } from '@store/tempDashboard/selectors';

export const PreManualAlertDiagnostics = () => {
  const dispatch = useDispatch();
  const dashboards = useSelector(dashboardsSelector);
  const query = useLocationQuery();
  const e = query.get('event');
  if (!e) {
    return <PageNotFound />;
  }
  const eventId = parseInt(e, 10);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { loading, data } = useQuery(ALERT_EVENT_QUERY, {
    variables: { ids: [eventId] },
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const event = get(data, 'manualAlertEvents.0', null) as ManualAlertEvent;
    if (!event || loading) {
      return;
    }

    for (const dashboardID of Object.keys(dashboards)) {
      const dashboard = dashboards[dashboardID];
      if (
        dashboard.type === DASHBOARD_TYPE.ALERT_DIAGNOSTICS &&
        get(dashboard, 'dashboard.module:trends.alerts.selectedEvent.id', null) === eventId
      ) {
        dispatch(push(`${TEMP_DASHBOARD_URL[DASHBOARD_TYPE.ALERT_DIAGNOSTICS]}${dashboardID}`));
        return;
      }
    }

    const alertName = get(event, 'alert.name');
    const { id, name, rule, isAdvanced } = get(event, 'alert.filter') as Filter;
    const appliedFilter = {
      fid: id,
      name,
      rule,
      isAdvanced,
    };

    const preferEndTime = moment(event.time).add(3, 'hour');
    const now = moment();
    const endTime = (now.isAfter(preferEndTime) ? preferEndTime : now).startOf('minute');

    const interval = {
      from: moment(endTime).subtract(6, 'hours'),
      to: endTime,
    };

    const dashboard = {
      common: {
        appliedFilters: [appliedFilter],
        interval,
      },
      ['module:trends']: {
        alerts: {
          selectedEvent: event,
        },
      },
    };

    dispatch(
      createTempDashboard(DASHBOARD_TYPE.ALERT_DIAGNOSTICS, dashboard, `Alert: ${alertName}`),
    );
  }, [data, loading]);

  if (loading) {
    return <Loading />;
  } else if (!get(data, 'manualAlertEvents.0')) {
    return <PageNotFound />;
  }

  return null;
};
